module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "Chapter_One_Stalins_Armoured_Fist"
    }
  }, [_c('p', {
    staticClass: "centerImage"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "id": "pg_8_1",
      "src": "images/pg_8_1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("In the 1930s much of the Red Army’s armour comprised the BT ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Bystrokhodnii")]), _vm._v(") fast tank; the BT-5 (in fact a copy of the US Christie M-1931) is identifiable by its cylindrical turret housing a 45mm gun. The BT was unusual in that it could run on roads at high speeds off its tracks; with a crew of three and a weight of 11.5 tons it could manage 70mph. However, it was time-consuming taking the tracks off and in a country lacking paved roads was not a great asset. ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Author’s Collection")]), _vm._v(")")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12f11166","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/06_01_Chapter_One.vue
// module id = 78
// module chunks = 0